import type { IconData } from '@stacksjs/iconify-core'

export const computersDevicesElectronicsMonitor: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 21.33H1.52V1.52H0V25.9h1.52v1.52h9.15v1.53h1.52v-1.53h7.62v1.53h1.52v-1.53h9.15V25.9H32V1.52h-1.52z\"/><path fill=\"currentColor\" d=\"M22.86 9.14h1.52V7.61h1.52V6.09h-1.52V4.57h-1.52v1.52h-1.53v1.52h1.53zM10.67 30.47v-1.52H9.14V32h13.72v-3.05h-1.53v1.52zm9.14-19.81h1.52v1.53h-1.52Zm-9.14 4.57h10.66v1.53H10.67Zm0-4.57h1.52v1.53h-1.52ZM1.52 0h28.96v1.52H1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default computersDevicesElectronicsMonitor
